import { Button, InputNumber, Select, Tag } from "antd";
import { get } from "lodash";
import { BiTrash } from "react-icons/bi";
import PricingInput from "./PricingInput";

const REIMBURSEMENT_TYPES = [
  { value: "brss", label: "% BRSS" },
  { value: "pmss", label: "% PMSS" },
  { value: "flat", label: "Montant fixe" },
];

const BenefitRow = ({
  mapping,
  showPricing,
  onRemove,
  onFieldChange,
  onPricerChange,
  zones,
  ageBrackets,
  regimes,
}) => {
  const benefit = get(mapping, "coverage", {});
  const limits = get(mapping, "limits", []);

  const reimbursementType = get(mapping, "reimbursementAmount")
    ? "flat"
    : get(mapping, "pmssPercentage")
      ? "pmss"
      : "brss";

  const reimbursementValue =
    reimbursementType === "flat"
      ? get(mapping, "reimbursementAmount")
      : reimbursementType === "pmss"
        ? get(mapping, "pmssPercentage")
        : get(mapping, "brssPercentage");

  const saveField = (field, val) => {
    onFieldChange(field, val);
  };

  const handleReimbursementTypeChange = (type) => {
    const data = {
      brssPercentage: null,
      pmssPercentage: null,
      reimbursementAmount: null,
    };
    if (type === "brss") data.brssPercentage = reimbursementValue;
    else if (type === "pmss") data.pmssPercentage = reimbursementValue;
    else data.reimbursementAmount = reimbursementValue;

    onFieldChange("brssPercentage", data.brssPercentage, true);
    onFieldChange("pmssPercentage", data.pmssPercentage, true);
    onFieldChange("reimbursementAmount", data.reimbursementAmount, true);
    onFieldChange("_batch", data);
  };

  const reimbursementField =
    reimbursementType === "flat"
      ? "reimbursementAmount"
      : reimbursementType === "pmss"
        ? "pmssPercentage"
        : "brssPercentage";

  const reimbursementSuffix = reimbursementType === "flat" ? "€" : "%";

  return (
    <div className="benefit-row">
      <div className="d-flex justify--between" style={{ alignItems: "center" }}>
        <div>
          <span className="benefit-row__title">
            {benefit.type}
          </span>
          {benefit.subtype && (
            <span className="benefit-row__subtitle"> — {benefit.subtype}</span>
          )}
          {benefit.requirement && (
            <span className="benefit-row__subtitle" style={{ marginLeft: 8 }}>
              ({benefit.requirement})
            </span>
          )}
        </div>
        <Button
          type="text"
          danger
          icon={<BiTrash size={16} />}
          onClick={onRemove}
        />
      </div>

      <div className="benefit-row__fields">
        <div className="benefit-row__field">
          <label>Remb. :</label>
          <Select
            size="small"
            value={reimbursementType}
            onChange={handleReimbursementTypeChange}
            style={{ width: 100 }}
          >
            {REIMBURSEMENT_TYPES.map((t) => (
              <Select.Option key={t.value} value={t.value}>
                {t.label}
              </Select.Option>
            ))}
          </Select>
          <InputNumber
            size="small"
            min={0}
            step={0.01}
            value={reimbursementValue}
            onChange={(val) => saveField(reimbursementField, val)}
            style={{ width: 80 }}
            addonAfter={reimbursementSuffix}
            placeholder={reimbursementType === "flat" ? "0.00" : "100"}
          />
        </div>
        <div className="benefit-row__field">
          <label>Carence :</label>
          <InputNumber
            size="small"
            min={0}
            value={get(mapping, "carenceDays")}
            onChange={(val) => saveField("carenceDays", val)}
            style={{ width: 80 }}
            addonAfter="j"
            placeholder="0"
          />
        </div>
        <div className="benefit-row__field">
          <label>Franchise :</label>
          <InputNumber
            size="small"
            min={0}
            step={0.01}
            value={get(mapping, "franchiseAmount")}
            onChange={(val) => saveField("franchiseAmount", val)}
            style={{ width: 90 }}
            addonAfter="€"
            placeholder="0"
          />
        </div>
        <Tag>{limits.length} limite(s)</Tag>
      </div>

      {showPricing && (
        <div className="benefit-row__pricing">
          <label>Tarification</label>
          <PricingInput
            value={get(mapping, "pricer.prices")}
            zones={zones}
            ageBrackets={ageBrackets}
            regimes={regimes}
            onChange={onPricerChange}
          />
        </div>
      )}
    </div>
  );
};

export default BenefitRow;
